import { Image, Link, Text, useBreakpointValue } from '@chakra-ui/react';

import { FinishLineGuy } from '../../../assets/Images';
import getSearchPhoneNumbers from '../../../utils/getSearchPhoneNumbers';
import { DealWithFarthestState } from '../utils';
import DashboardStateCard from './DashboardStateCard';

const StructuringDashboard = ({
  deal,
  showPayoffIntelligenceVariation,
}: {
  deal?: DealWithFarthestState;
  showPayoffIntelligenceVariation?: boolean;
}) => {
  const phoneNumber = getSearchPhoneNumbers();
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <DashboardStateCard
      deal={deal}
      header="We're so close!"
      subheader={showPayoffIntelligenceVariation ? null : 'Your lease buyout journey is underway.'}
      body={
        <Text>
          {showPayoffIntelligenceVariation ? 'Your lease buyout journey is underway. ' : ''}Every
          buyout is different—we're reviewing your options and will reach out soon with next steps.{' '}
          {showPayoffIntelligenceVariation ? (
            ''
          ) : (
            <>
              Want to talk sooner? Give us a call at{' '}
              <Link href={`tel:+1-${phoneNumber}`}>{phoneNumber}</Link>.
            </>
          )}
        </Text>
      }
      image={
        isMobile && showPayoffIntelligenceVariation ? null : (
          <Image p={4} src={FinishLineGuy} alt="Finish Line" />
        )
      }
    />
  );
};

export default StructuringDashboard;
